module.exports = __webpack_public_path__ + "img/grey_romb.cf443de7.png";